import { ErrorBoundary } from "react-error-boundary";

// routes
import { Routes } from "./router/file-routing";

// contexts
import AllContexts from "./contexts/root";

// hooks
import { useIsMobileDevice } from "./hooks/useIsMobileDevice";

// components
import ErrorComponent from "./components/404ErrorComponent";
import ServiceWorkerPrompt from "./components/ServiceWorkerPrompt";
import { ConfirmationModal } from "./components/ConfirmationModal";
import { TermsConditionsModalModal } from "./components/TermsConditionsModal";
import { MobilePullToRefresh } from "./components/MobilePullToRefresh";

const App: React.FC = () => {
  const isMobileDevice = useIsMobileDevice();

  return (
    // this top error boundary should use a non context based components (just div's and css)
    <ErrorBoundary
      FallbackComponent={ErrorComponent}
      onError={(err) => {
        // oxlint-disable-next-line no-console
        console.error(err);
      }}
    >
      <AllContexts>
        <ErrorBoundary
          FallbackComponent={ErrorComponent}
          onError={(err) => {
            // oxlint-disable-next-line no-console
            console.error(err);
          }}
        >
          <Routes />
          <ConfirmationModal />
          {isMobileDevice && <MobilePullToRefresh />}
          <ServiceWorkerPrompt />
          <TermsConditionsModalModal />
        </ErrorBoundary>
      </AllContexts>
    </ErrorBoundary>
  );
};

export default App;
